<template>
  <Layout style="height: 100%" class="main">
  <div v-if="showleft" style=" background: #2f4050 !important;"> 
  <Button @click="showleft=false;" size="small" style="text-align: left;width: 100%;"title="隐藏左侧导航"><Icon type="md-arrow-round-back" /></Button>
    <Sider
      hide-trigger
      collapsible
      :width="146"
      :collapsed-width="64"
      v-model="collapsed"
      class="left-sider"
      :style="{ overflow: 'hidden' }"
    >
      <side-menu
        accordion
        ref="sideMenu"
        :active-name="$route.name"
        :collapsed="collapsed"
        @on-select="turnToPage"
        :menu-list="menuList"
      >
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con">
         <a title="首页" target="_blank" href="/"><img v-show="!collapsed" :src="maxLogo" key="max-logo" style="cursor:pointer;" /></a>
         <a title="首页" target="_blank" href="/"><img v-show="collapsed" :src="minLogo" key="min-logo" style="cursor:pointer;" /></a>
        </div>
      </side-menu>
    </Sider>
	</div>
    <Layout>
      <!-- <Header class="header-con">
        <header-bar
          :collapsed="collapsed"
          @on-coll-change="handleCollapsedChange"
        >
        </header-bar>
      </Header> -->
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <sider-trigger
              :collapsed="collapsed"
              icon="md-menu"
              @on-change="handleCollpasedChange"
            ></sider-trigger>
            <tags-nav
              :value="$route"
              @input="handleClick"
              :list="tagNavList"
              @on-close="handleCloseTag"
            />
            <fullscreen v-model="isFullscreen" style="margin-left: 10px;" />
            <Badge :count="tipcount" style="size:10px;margin-left: 6px;margin-right: 6px;cursor:pointer" @click="updateLog">
			
			<Poptip word-wrap title="通知" placement="bottom-end" width="600">
			  <Icon size="24" type="ios-notifications" :style="tipcolor" @click="updateLog" title="工厂通知提醒" />
			  <div slot="title">
			  <span style="font-size:15px;font-weight:bold;">通知</span>&nbsp;&nbsp;&nbsp;<a target="_blank" href="/product/notice">更多通知</a>
			  </div>
			  <div class="api" slot="content">
						  
					<vxe-table
					 style="max-height:700px;"
					  border
					  stripe
					  keep-source
					  size="mini"
					  :data="updateLogData"
					  :column-config="{ resizable: true }"
					  :row-config="{ isHover: true }"
					>
						<vxe-column title="时间" width="111">
						  <template #default="{ row }">
							  <div>{{ row.time }}</div>
							  <div>{{ row.notifier }}</div>
						  </template>
						</vxe-column>
						<vxe-column title="标题" width="99">
						  <template #default="{ row }">
							  <span>{{ row.name }}</span>
						  </template>
						</vxe-column>
						<vxe-column title="内容">
						  <template #default="{ row }">
							<Poptip transfer 
              trigger="hover" max-width="500">
								<span>{{ row.content.length>30?(row.content.substr(0,30)+'...'):row.content }}</span>
							  <div class="api" slot="content">
								<div style="white-space: pre-wrap;">{{ row.content }}</div>
							  </div>
							</Poptip>
						  </template>
						</vxe-column>
						<vxe-column title="操作" width="80">
						  <template #default="{ row }">
							  <Button type="primary" v-if="row.read==0" @click="read(row)" title="点击标识已读">我已读</Button>
							  <div v-if="row.read!=0" style="color:#00b105;">已读</div>
						  </template>
						</vxe-column>
					</vxe-table>
			  </div>
			</Poptip>
			
            </Badge>
            <Badge :count="oatipcount" style="size:10px;margin-left: 6px;margin-right: 6px;cursor:pointer" @click="updateLog">
			<Poptip word-wrap title="OA任务" placement="bottom-end" width="600">
			  <Icon size="24" type="ios-chatboxes" :style="oatipcolor" @click="updateLog" title="OA任务提醒" />
			  <div slot="title">
			  <span style="font-size:15px;font-weight:bold;">OA</span>&nbsp;&nbsp;&nbsp;<a target="_blank" href="/oa/oatask">更多OA任务</a>
			  </div>
			  <div class="api" slot="content">
						  
					<vxe-table
					 style="max-height:700px;"
					  border
					  stripe
					  keep-source
					  size="mini"
					  :data="oaData"
					  :column-config="{ resizable: true }"
					  :row-config="{ isHover: true }"
					>
						<vxe-column title="状态" width="88">
						  <template #default="{ row }">
            <div v-if="row.finishstatusname=='已逾期'" style="color:red;">{{ row.finishstatusname }}</div>
            <div v-if="row.finishstatusname=='已完成'" style="color:#19be6b;">{{ row.finishstatusname }}</div>
            <div v-if="row.finishstatusname=='进行中'" style="color:#409eff;">{{ row.finishstatusname }}</div>
            <div v-if="row.finishstatusname=='取消不做'" style="color:grey;">{{ row.finishstatusname }}</div>
						  </template>
						</vxe-column>
						<vxe-column title="时间" width="133">
						  <template #default="{ row }">
							  <div>{{ row.createtime }}</div>
							  <div>{{ row.createuser }}</div>
						  </template>
						</vxe-column>
						<vxe-column title="任务名称" width="99">
						  <template #default="{ row }">
							  <span>{{ row.name }}</span>
						  </template>
						</vxe-column>
						<vxe-column title="任务描述">
						  <template #default="{ row }">
							<Poptip transfer 
              trigger="hover" max-width="500">
								<span>{{ row.description.length>30?(row.description.substr(0,30)+'...'):row.description }}</span>
							  <div class="api" slot="content">
								<div style="white-space: pre-wrap;">{{ row.description }}</div>
							  </div>
							</Poptip>
						  </template>
						</vxe-column>
						<vxe-column title="操作" width="80">
						  <template #default="{ row }">
							  <Button type="primary" v-if="row.read==2" @click="readoa(row)" title="点击标识已读">我已读</Button>
							  <div v-if="row.read!=2" style="color:#00b105;">已读</div>
						  </template>
						</vxe-column>
					</vxe-table>
			  </div>
			</Poptip>
            </Badge>
			<!--
			<Poptip word-wrap title="近30天下载记录" placement="bottom-end" width="400">
			  <Icon size="24" type="md-download" style="cursor:pointer" @click="downLog" />
			  <div class="api" slot="content">
						  
					<vxe-table
					 style="max-height:400px;"
					  border
					  stripe
					  keep-source
					  size="mini"
					  :data="downLogData"
					  :column-config="{ resizable: true }"
					  :row-config="{ isHover: true }"
					>
						<vxe-column title="时间" width="133">
						  <template #default="{ row }">
							  <span>{{ row.createtime }}</span>
						  </template>
						</vxe-column>
						<vxe-column title="标题" width="133">
						  <template #default="{ row }">
							  <span>{{ row.title }}</span>
						  </template>
						</vxe-column>
						<vxe-column title="状态">
						  <template #default="{ row }">
							  <span v-if="row.state==1"><a target="_blank" :href="row.fullurl" title="已完成，点击下载">下载</a></span>
							  <span v-if="row.state==2" style="color:orange;">生成中</span>
							  <span v-if="row.state==3" style="color:red;text-decoration: underline dotted;" :title="row.error">失败</span>
						  </template>
						</vxe-column>
					</vxe-table>
			  </div>
			</Poptip>
			-->
            <user
              :message-unread-count="unreadCount"
              :user-avatar="userAvatar"
            />
			
          </div>
          <Content class="content-wrapper">
            <keep-alive :include="cacheList">
              <router-view />
            </keep-alive>
            <ABackTop
              :height="100"
              :bottom="80"
              :right="50"
              container=".content-wrapper"
            ></ABackTop>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import { 
updateLog,downLog
} from "@/api/simpleList";
import { 
noticeRead,oataskEdit
} from "@/api/record";
import siderTrigger from "./components/header-bar/sider-trigger";
import SideMenu from "./components/side-menu";
import HeaderBar from "./components/header-bar";
import TagsNav from "./components/tags-nav";
import User from "./components/user";
import ABackTop from "./components/a-back-top";
import Fullscreen from "./components/fullscreen";
import ErrorStore from "./components/error-store";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { getNewTagList, routeEqual } from "@/utils/util";
import routers from "@/router/routers";
import minLogo from "@/assets/images/logo-min.png";
import maxLogo from "@/assets/images/logo.png";
import "./main.less";
export default {
  name: "Main",
  components: {
    siderTrigger,
    SideMenu,
    HeaderBar,
    TagsNav,
    Fullscreen,
    ErrorStore,
    User,
    ABackTop
  },
  data() {
    return {
      interval:null,
      tipcount:0,
      oatipcount:0,
      tipcolor: '',
      oatipcolor: '',
      downLogData: [],
      updateLogData: [],
      oaData: [],
      showleft: true,
      collapsed: true,
      minLogo,
      maxLogo,
      isFullscreen: false
    };
  },
  computed: {
    ...mapGetters(["errorCount"]),
    tagNavList() {
      return this.$store.state.app.tagNavList;
    },
    tagRouter() {
      return this.$store.state.app.tagRouter;
    },
    userAvatar() {
      // return "https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3491929439,4106440758&fm=26&gp=0.jpg";
      return this.$store.state.user.avatarImgPath;
    },
    cacheList() {
      const list = [
        "ParentView",
        ...(this.tagNavList.length
          ? this.tagNavList
              .filter(item => !(item.meta && item.meta.notCache))
              .map(item => item.name)
          : [])
      ];
      return list;
    },
    menuList() {
      // console.log(this.$store.state.user.menuList);
      return this.$store.state.user.menuList;
      // return this.$store.getters.menuList;
    },
    local() {
      return this.$store.state.app.local;
    },
    hasReadErrorPage() {
      return this.$store.state.app.hasReadErrorPage;
    },
    unreadCount() {
      return this.$store.state.user.unreadCount;
    }
  },
	created() {
	this.updateLog();
	this.updateLogsetInterval();
  },
  methods: {
	updateLogsetInterval(){
      this.interval = setInterval(() => {
        this.updateLog(); // 更新数据
      }, 10000); // 每1000毫秒更新一次
	  
	},
    ...mapMutations([
      "setBreadCrumb",
      "setTagNavList",
      "addTag",
      "setLocal",
      "setHomeRoute",
      "closeTag"
    ]),
    ...mapActions(["handleLogin", "getUnreadMessageCount"]),
    turnToPage(route) {
      let { name, params, query } = {};
      if (typeof route === "string") name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (name.indexOf("isTurnByHref_") > -1) {
        window.open(name.split("_")[1]);
        return;
      }
      // 此处判断是否还在当前路由 在就return 避免控制台报错
      if (name === this.$router.currentRoute.name) {
        return false;
      }
	  
	  //不弹出新窗口
		// this.$router.push({
        // name,
        // params,
        // query
      // });
	  
	  // 弹出新窗口
      const routerJump = this.$router.resolve({
        name,
        params,
        query
      });
      window.open(routerJump.href, "_blank");
    },
    async read(row) {
			let params = new FormData();
			params.append("id", row.id);
			let res=await noticeRead(params);
			if(res.data.code==1){
				row.read=1;
				this.updateLog();
			}
    },
    async readoa(row) {
        let params = new FormData();
        params.append("ids",row.id);
        params.append("row[isread]", 1);
        this.readBtn = true;
        const res = await oataskEdit(params);
        this.readBtn = false;
        if (res && res.data.code === 1) {
				this.updateLog();
        } else {
          this.$Message.error(res.data.msg );
        }
    },
    handleCollpasedChange(state) {
		if(!this.showleft)  state = true;
		this.showleft=true;
      this.collapsed = state;
    },
    handleCloseTag(res, type, route) {
      if (type !== "others") {
        if (type === "all") {
          this.turnToPage(this.$config.homeName);
        } else {
          if (routeEqual(this.$route, route)) {
            this.closeTag(route);
          }
        }
      }
      this.setTagNavList(res);
    },
	async updateLog(){
			if(!this.$store.getters.token) return false;
			let res=await updateLog();
			if(res.data.data&&res.data.data.notice) this.updateLogData=res.data.data.notice||[];
			if(res.data.data&&res.data.data.oa) this.oaData=res.data.data.oa||[];
			this.oatipcount=this.oaData.length;//未读条数
			this.tipcount=parseInt(res.data.code||0);//未读条数
			if(this.tipcount>0) this.tipcolor="color:red;";
			else  this.tipcolor="color:;";
			
			if(this.oatipcount>0) this.oatipcolor="color:red;";
			else  this.oatipcolor="color:;";
			//前端更新时间
			let htmltime=res.data.msg;
			if(htmltime){
				let site_v=this.$cookies.get("site_v");
				if(htmltime!=site_v){
					this.$cookies.set("site_v", htmltime, { expires: 30 });
					if(htmltime==this.$cookies.get("site_v")){
						window.location.reload(true); // 重新加载页面并丢弃缓存
						// location.reload(true); // 重新加载页面并丢弃缓存 仅支持firefox
					}
				}
			}
		
	},
	async downLog(){
		this.downLogData=[];
		let res=await downLog();
		if(res.data.code==1){
			this.downLogData=res.data.data;
		}
	},
    handleClick(item) {
      this.turnToPage(item);
    }
  },
  watch: {
    $route(newRoute) {
      const { name, params, meta } = newRoute;
      this.addTag({
        route: { name, params, meta },
        type: "push"
      });
      this.setBreadCrumb(newRoute);
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute));
      this.$refs.sideMenu.updateOpenName(newRoute.name);
    }
  },
  mounted() {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
	 if(this.$router.currentRoute.name=='cprd'){ //补货页面默认隐藏左导航
		 this.showleft=false;
	 }
    this.setTagNavList();
    this.setHomeRoute(routers);
    const { name, params, meta } = this.$route;
    this.addTag({
      route: { name, params, meta }
    });
    this.setBreadCrumb(this.$route);

    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      });
    }
    // 获取未读消息条数
    this.getUnreadMessageCount();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/main/main.vue